export const POPUP_SHOW        = "POPUP.SHOW";
export const POPUP_HIDE        = "POPUP.HIDE";
export const POPUP_SET_TITLE   = "POPUP.SET_TITLE";
export const POPUP_SET_CONTENT = "POPUP.SET_CONTENT";